<template>
  <div class="dropdown">
    <!-- <button class="dropbtn">Dropdown</button> -->
    <kendo-button
      name="Pick"
      class="k-outline btn-ht btn-rect mr-1"
      type="button"
      @click="toggleDropdown"
    >
      <span class="title-icon">
        <span class="nt-eye"></span>
      </span>
      <span class="pd-view">View</span>
    </kendo-button>

    <div
      class="dropdown-content"
      v-show="dropDownState"
      :style="[dropDownSide === 'right' ? { right: 0 } : '']"
    >
      <div v-for="d in dataItems" :key="d.field">
        <div class="dropdown-checkbox" v-if="!d.ignoreCheckbox">
          <span v-if="d.defaultSelected === false">
            <input
              type="checkbox"
              v-model="d.checked"
              name=""
              @change="onSelect({ event: $event, item: d })"
            />
            <span class="chk-title"> {{ d.title }} </span>
          </span>
          <span v-else>
            <input
              type="checkbox"
              v-model="d.checked"
              name=""
              @change="onSelect({ event: $event, item: d })"
              disabled
            />
            <span class="chk-title"> {{ d.title }} </span>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return { dropDownState: false };
  },
  props: {
    dataItems: Array,
    dropDownSide: String,
  },
  methods: {
    onSelect: function (obj) {
      this.$emit("columnChange", obj);
    },
    toggleDropdown() {
      this.dropDownState = !this.state;
    },
    close(e) {
      if (!this.$el.contains(e.target)) {
        this.dropDownState = false;
      }
    },
  },
  mounted() {
    document.addEventListener("click", this.close);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.close);
  },
};
</script>

<style scoped lang="scss">
.k-button {
  border-radius: 20px;
  -webkit-box-shadow: none;
  box-shadow: none;
  background: transparent;
  padding: 8px 10px;
  font-weight: 500;
  font-size: 14px;
  // color: rgba(197, 197, 197, 0.568);
  color: #73a0a0a6;
  border: 0;
  line-height: 0;
  border-radius: 3px;
}
.k-button:hover {
  background: #233eac;
  color: #ffffff;
}
.pd-view {
  padding-left: 5px;
  font-size: 13px;
}

/* Dropdown Button */
.dropbtn {
  background-color: #4caf50;
  color: white;
  padding: 16px;
  font-size: 16px;
  border: none;
}

/* The container <div> - needed to position the dropdown content */
.dropdown {
  position: relative;
  display: inline-block;
}

/* Dropdown Content (Hidden by Default) */
.dropdown-content {
  display: none;
  position: absolute;
  background-color: #ffffff;
  width: 180px;
  z-index: 2;
  max-height: 300px;
  overflow-y: auto;
  box-shadow: rgba(0, 0, 0, 0.133) 0px 3.2px 7.2px 0px,
    rgba(0, 0, 0, 0.11) 0px 0.6px 1.8px 0px;
}

/* Links inside the dropdown */
.dropdown-content .dropdown-checkbox {
  color: black;
  padding: 6px 10px;
  text-decoration: none;
  display: flex;
  align-items: center;
  span {
    display: flex;
    align-items: center;
  }
}

/* Change color of dropdown links on hover */
.dropdown-content .dropdown-checkbox:hover {
  background-color: #ddd;
}

/* Show the dropdown menu on hover */
/* .dropdown:hover .dropdown-content */
.dropdown .dropdown-content {
  display: block;
}

/* Change the background color of the dropdown button when the dropdown content is shown */
.dropdown:hover .dropbtn {
  background-color: #3e8e41;
}

.chk-title {
  margin-left: 5px;
  color: #666;
}
</style>
